import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum CreateProductFamilyProgressStep {
  Uploading = "uploading",
  Analyzing = "analyzing",
  Creating = "creating",
}
export const CreateProductFamilyProgressStepSchema = createEnum(
  CreateProductFamilyProgressStep,
);

const ProgressUpdateSchema_ = z.object({
  type: z.literal("progress"),
  step: CreateProductFamilyProgressStepSchema,
  message: z.string(),
});
export const ProgressUpdateSchema: z.ZodType<ProgressUpdate> =
  ProgressUpdateSchema_;
export interface ProgressUpdate extends z.infer<typeof ProgressUpdateSchema_> {}

const CompletedUpdateSchema_ = z.object({
  type: z.literal("completed"),
  productFamilyId: productFamilyIdFormat.schema,
  productId: productIdFormat.schema,
  title: z.string(),
  description: z.string(),
  imageUrl: z.string(),
});
export const CompletedUpdateSchema: z.ZodType<CompletedUpdate> =
  CompletedUpdateSchema_;
export interface CompletedUpdate extends z.infer<
  typeof CompletedUpdateSchema_
> {}

export const CreateProductFromImagesUpdateSchema = z.discriminatedUnion(
  "type",
  [ProgressUpdateSchema_, CompletedUpdateSchema_],
);
export type CreateProductFromImagesUpdate = z.infer<
  typeof CreateProductFromImagesUpdateSchema
>;

export const createProductFamilyFromImages = unaryStreamRpc({
  name: "createProductFamilyFromImages" as const,
  input: z.object({ images: z.array(z.string()) }),
  output: CreateProductFromImagesUpdateSchema,
});
